import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getToDateEndingIsYesterdayPreference } from "../store/report/reportActions";

const useToDateEndingIsYesterday = () => {
  const dispatch = useDispatch();
  const useYesterday = useSelector((state) => state.report.toDateEndingIsYesterday);
  const hasDispatched = useRef(false);
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (hasDispatched.current) return;
    hasDispatched.current = true;
    dispatch(getToDateEndingIsYesterdayPreference());
  }, [dispatch]);

  useEffect(() => {
    if (useYesterday === true || useYesterday === false) {
      setValue(useYesterday);
    }
  }, [useYesterday]);

  return value;
};

export default useToDateEndingIsYesterday;
